/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {FormLabelDefaultExample, FormLabelVerticalExample, FormLabelNoForIdExample, FormLabelLinkedLabelExample} from 'Docs/uilib/components/form-label/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default form-label"
    }), "\n", _jsx(FormLabelDefaultExample, {}), "\n", _jsx(_components.h3, {
      children: "Vertical form-label"
    }), "\n", _jsx(FormLabelVerticalExample, {}), "\n", _jsxs(_components.h3, {
      children: ["Vertical form-label without a ", _jsx(_components.code, {
        children: "for_id"
      })]
    }), "\n", _jsx(FormLabelNoForIdExample, {}), "\n", _jsx(_components.h3, {
      children: "Linked label (pattern)"
    }), "\n", _jsx(FormLabelLinkedLabelExample, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
